import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom'
import TableRowCommon from '../../../../components/table/TableRowCommon';
import { useMediaQuery, useTheme } from '@mui/material';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import { create_library, library_type_list, LibraryTypeApi } from '../../../../api/library-type/library_type.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { index_media_type, MEDIA_TYPE, media_type_data } from '../../enum/elibrary_enum';
import { produce } from 'immer';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import moment from 'moment';
import { dateTimeToView } from '../../../../utils/date.utils';


export const useManageState = () => {
    // CONSTANCE
    const dispatch = useDispatch();
    const location = useLocation();
    const pathname = location.pathname;
    const { t } = useTranslation();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));


    const [formState, setFormState] = useState<{ library_type_name: string, id_library_type: number | null }>({
        id_library_type: null,
        library_type_name: ""
    })
    const [media_type, set_media_type] = useState<{ name: string, value: string, checked: boolean }[]>(media_type_data.map((list) => {
        return {
            checked: false,
            name: list.name,
            value: list.value
        }
    }))


    // HOOKS
    const [search, set_search] = useState<string>("");
    const [start_date, set_start_date] = useState<string | null>(null);
    const [end_date, set_end_date] = useState<string | null>(null);
    const [category_library, set_category_library] = useState<string>("");

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("created_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, set_data] = useState<any[]>([]);
    const [showModal, set_showModal] = useState<string>("");

    const handleCloseModal = () => {
        set_showModal("");
        setFormState({ library_type_name: "", id_library_type: null });
        set_media_type((prev) => prev.map((x) => ({ ...x, checked: false })));
    }
    const handleCheckedMediaType = (index: number) => {
        set_media_type(prev =>
            produce(prev, draft => {
                if (draft[index]) {
                    draft[index].checked = !draft[index].checked;
                }
            })
        );
    };
    const handleChangeDateRange = (st: string | null, end: string | null) => {
        set_start_date(st);
        set_end_date(end);
    }

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_library_type", width: 50, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อหมวดหมู่")
        },
        {
            id: "ๅ", disablePadding: false, align: "center", width: 140, label: t("ประเภทสื่อ")
        },
        {
            id: "4", disablePadding: false, align: "center", width: 141, label: t("ผู้ที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "5", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/ปรับปรุงล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            library_type_name,
            created_by,
            modified_date,

            id_library_type,
            books,
            e_books,
            magazine,
            podcast,
            thesis,
            video,
            audio_books,
            modified_by
        } =
            objData;

        const check_media: { key: string, name: string, value: boolean }[] = [
            {
                key: MEDIA_TYPE.BOOK,
                name: index_media_type[0],
                value: !!books
            },
            {
                key: MEDIA_TYPE.E_BOOK,
                name: index_media_type[1],
                value: !!e_books
            },
            {
                key: MEDIA_TYPE.MAGAZINE,
                name: index_media_type[2],
                value: !!magazine
            },
            {
                key: MEDIA_TYPE.THESIS,
                name: index_media_type[3],
                value: !!thesis
            },
            {
                key: MEDIA_TYPE.PODCAST,
                name: index_media_type[4],
                value: !!podcast
            },
            {
                key: MEDIA_TYPE.AUDIO_BOOK,
                name: index_media_type[5],
                value: !!audio_books
            },
            {
                key: MEDIA_TYPE.VIDEO,
                name: index_media_type[6],
                value: !!video
            },
        ]
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no },
                {
                    option: "TEXT",
                    align: "left",
                    label: library_type_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: check_media?.filter((x) => x.value).map((x) => x.name).join(" ,"),
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-"
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit
                            enableView
                            enableDelete
                            onViewClick={() => {
                                set_showModal("VIEW");
                                set_media_type((prev) => prev.map((list) => {
                                    return {
                                        ...list,
                                        checked: !!check_media?.find((x) => x.key === list.value)?.value
                                    }
                                }))
                                setFormState({
                                    id_library_type: id_library_type, library_type_name
                                });
                            }}
                            onEditClick={() => {
                                set_showModal("EDIT");
                                set_media_type((prev) => prev.map((list) => {
                                    return {
                                        ...list,
                                        checked: !!check_media?.find((x) => x.key === list.value)?.value
                                    }
                                }))
                                setFormState({
                                    id_library_type: id_library_type, library_type_name
                                });
                            }}
                            onDeleteClick={() => handleDeleteList(id_library_type)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_library_type: number) => {
        alertActive("ลบรายการ", "ท่านต้องการลบรายการนี้?", undefined, undefined, async () => {
            dispatch(setLoading());
            await LibraryTypeApi.delete(id_library_type).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว");
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const generateBody = (): create_library => {
        const isChecked = (type: MEDIA_TYPE) =>
            media_type?.some((x) => x.value === type && x.checked) || false;
        return {
            library_type_name: formState.library_type_name,
            audio_books: isChecked(MEDIA_TYPE.AUDIO_BOOK),
            books: isChecked(MEDIA_TYPE.BOOK),
            e_books: isChecked(MEDIA_TYPE.E_BOOK),
            magazine: isChecked(MEDIA_TYPE.MAGAZINE),
            podcast: isChecked(MEDIA_TYPE.PODCAST),
            thesis: isChecked(MEDIA_TYPE.THESIS),
            video: isChecked(MEDIA_TYPE.VIDEO),
        }
    }

    const handleSubmit = async () => {
        const body = generateBody();
        dispatch(setLoading());
        if (formState.id_library_type) {
            await LibraryTypeApi.update(formState.id_library_type, body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("อัพเดตหมวดหมู่", "อัพเดตหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {

            await LibraryTypeApi.create(body).then((res) => {
                if (res.status < 300) {
                    handleGetData();
                    handleCloseModal();
                    alertSuccess("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ สำเร็จ");
                }
            }).catch((err) => {
                console.log(err);
                alertError("เพิ่มหมวดหมู่", "เพิ่มหมวดหมู่ ไม่สำเร็จ");
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
        // console.log(body, 'body');
    }

    const handleGetData = useCallback(async () => {
        let query: library_type_list = {
            page: page,
            limit: pageLimit,
            sortBy: sortBy,
            sortType: sortType
        }
        if (search) query.search = search
        if (category_library) query.category_library = category_library
        if (start_date) query.start_date = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.start_date = moment(end_date).format("YYYY-MM-DD");
        dispatch(setLoading());
        await LibraryTypeApi.list(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
                set_data(response)
                // console.log(response, 'data')
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, sortBy, sortType, category_library, start_date, end_date, search])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])

    return {
        pathname,
        set_search,
        handleChangeDateRange,
        start_date,
        end_date,
        page,
        pageLimit,
        totalItems,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        media_type,
        showModal,
        handleCloseModal,
        set_showModal,
        handleCheckedMediaType,
        handleSubmit,
        category_library,
        set_category_library,
        setFormState,
        formState
    }
}

